import React from 'react';

function MembershipIcon({ className = '', fill = '#212121' }) {
	return (
		<svg
			className={className}
			width='48'
			height='48'
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_6_12284)'>
				<path
					d='M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z'
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_6_12284'>
					<rect width='48' height='48' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default MembershipIcon;
